(function ($) {

    // 搜索词
    var searchKeys = common.getSS('searchKeys', 1) || [];

    if(searchKeys.length === 0){
        getProductNames();
    }else{
        start(searchKeys);
    }

    // 获取产品标题
    function getProductNames() {
        common.getJson('/api/product/searchkeys','', function (res) {
            if(res.errCode === 0){
                common.setSS('searchKeys', res.data, 1);
                searchKeys = common.getSS('searchKeys', 1);
                start(searchKeys);
            }
        })
    }

    function initAutocomplete(ele, searchKeys) {
        if(ele.length === 0) {
            return;
        }

        ele.easyAutocomplete(getOption(ele));

        function getOption(ele) {
            return {
                data: searchKeys,
                adjustWidth: false,
                list: {
                    maxNumberOfElements: 10,
                    match: {
                        enabled: true
                    },
                    onClickEvent: function() {
                        console.log(this);
                        var keyWord = ele.getSelectedItemData();
                        gioEvarAction.searchEvar(keyWord);
                        if (common.isM){
                            serach.doSearch(keyWord);
                        }else{
                            window.open(solution_host+'/list' + '?type=' + window.cateData.searchType + '&kw=' +encodeURI(keyWord)+ '&ishot=5'+'&searchmodule=' + window.cateData.userRecodeOption.module);
                        }
                    }
                }
            };
        }


    }

    function start(searchKeys){

        if (common.isM){
            // 手机端
            initAutocomplete($("#serach-input"), searchKeys);
        }else{
            initAutocomplete($("#inputValue"), searchKeys);
            initAutocomplete($("#header-search-input"), searchKeys);
            initAutocomplete($("#product-search-input"), searchKeys);
        }

    }


// 对gio的推荐热词隐藏
    if (!common.isM){
        $("#header-search-input").keyup(function () {
            if(this.value){
                $('#eac-container-header-search-input').show();
                $('.searchBox .hot-search-content').hide();
            }else{
                $('.searchBox .hot-search-content').show();
            }
        });

        $("#inputValue").keyup(function () {
            if(this.value){
                $('#eac-container-header-search-input').show();
                $('.search-container .hot-search-content').hide();
            }else{
                $('.search-container .hot-search-content').show();
            }
        });

        $("#product-search-input").keyup(function () {
            if(this.value){
                $('#eac-container-header-search-input').show();
                $('#product-search .hot-search-content').hide();
            }else{
                $('#product-search .hot-search-content').show();
            }
        });
    }
})(jQuery);

